import { API_PREFIX } from "./api.constants";

export const AUTH_PROVIDER_ENDPOINTS = {
  PROVIDERS: `${API_PREFIX}/auth-providers`,
  PROVIDER_DETAIL: (providerId: number | string) => `${API_PREFIX}/auth-providers/${providerId}`,
  PUBLIC_PROVIDERS: `${API_PREFIX}/auth-providers/public/list`,
};